import api from './api';

export default {
  getAll() { return api.get('/payments'); },
  getById(id: number) { return api.get(`/payments/${id}`); },
  create(data: any) { return api.post('/payments', data); },
  uploadProof(id: number, formData: FormData) { 
    return api.post(`/payments/${id}/proof`, formData, { 
      headers: { 'Content-Type': 'multipart/form-data' } 
    }); 
  },
  verify(id: number, data: any) { return api.post(`/payments/${id}/verify`, data); },
  delete(id: number) { return api.delete(`/payments/${id}`); }
};
